class SearchDiscovery extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    let requestResponse;

    const body = document.body;
    const header = document.querySelector('header.header');
    const showSearch = document.querySelector('.js-show-search');
    const searchInput = this.querySelector('.js-search-discovery-input');
    const closeButton = this.querySelector('.js-search-discovery-suggestions-close');
    const searchSuggestionsSection = this.querySelector('.js-search-discovery-suggestions');
    const placeholderHTML = searchSuggestionsSection.querySelector('#shopify-section-search-discovery-suggestions').innerHTML;

    const classes = {
      active: 'search-discovery-active',
      suggestionsActive: 'search-discovery-suggestions-active',
      suggestionsGridActive: 'search-discovery-suggestions__grid--active',
      suggestionsControlsButtonActive: 'search-discovery-suggestions__controls-button--active', 
      suggestionsLoading: 'search-discovery-suggestions-loading'
    };

    const showPlaceholder = () => {
      searchSuggestionsSection.innerHTML = placeholderHTML;
      body.classList.remove(classes.suggestionsLoading);
      document.dispatchEvent(new Event('asyncSlider:ready'));
    };

    const addControlListeners = () => {
      const controlButtons = this.querySelectorAll('.js-search-discovery-suggestions-control-button');
      const searchSuggestionsGrids = this.querySelectorAll('.js-search-discovery-suggestions-grid');

      controlButtons.forEach((control) => {
        control.addEventListener('click', () => {
          const target = control.getAttribute('data-result-section');
          
          controlButtons.forEach((control) => {
            control.classList.remove(classes.suggestionsControlsButtonActive);
          })

          searchSuggestionsGrids.forEach((section) => {
            section.classList.remove(classes.suggestionsGridActive);

            if (section.getAttribute('data-result-section') === target) {
              section.classList.add(classes.suggestionsGridActive);
              control.classList.add(classes.suggestionsControlsButtonActive);
            }
          });
        });
      });
    };

    const closeSearch = () => {
      searchInput.blur();
      header.classList.remove('active');
      body.classList.remove(classes.active, classes.suggestionsActive);
    };

    showSearch.addEventListener('click', () => {
      searchInput.blur();
      body.classList.toggle(classes.active);
      body.classList.toggle(classes.suggestionsActive);
      header.classList.toggle('active');
    });

    this.addEventListener('transitionend', () => {
      if (body.classList.contains(classes.active) && searchInput.value == '') {
        searchInput.focus();
      }
    });

    searchInput.addEventListener('input', debounce((e) => {
      if (!e.target.value) {
        showPlaceholder();
        return;
      };

      if (body.classList.contains(classes.suggestionsLoading)) return;

      body.classList.add(classes.suggestionsLoading);

      fetch(`${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(e.target.value)}&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&section_id=search-discovery-suggestions`)
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          showPlaceholder();
          throw new Error(`${requestResponse.status}: ${text}`);
        }

        const results = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-search-discovery-suggestions').innerHTML;

          searchSuggestionsSection.innerHTML = results;
          body.classList.remove(classes.suggestionsLoading);
          document.dispatchEvent(new Event('asyncSlider:ready'));
          addControlListeners();
      })
      .catch((error) => {
        showPlaceholder();
        console.error(error);
      });
    }, 500));

    closeButton.addEventListener('click', () => {
      closeSearch();
    });

    document.addEventListener('searchDiscovery:close', () => {
      closeSearch();
    });

    addControlListeners();
  }
}

customElements.define('search-discovery', SearchDiscovery);
